import { useState, useEffect } from 'react'
import { Document, Page } from 'react-pdf'
import { pdfjs } from 'react-pdf'

import "react-pdf/dist/esm/Page/TextLayer.css"
import "react-pdf/dist/esm/Page/AnnotationLayer.css"

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

export async function loader({ params }) {
    return null;
}

export async function action({ params }) {
    return null;
}

export default function Resume() {
    // HACK: all this code just to get the screen size to render the pdf at a reasonable size.
    // HACK: this code is copy paste, refactor if possible
    const [screenSize, setScreenSize] = useState(getCurrentDimension());
    function getCurrentDimension() {
        return {
            width: window.innerWidth,
            height: window.innerHeight
        }
    }
    useEffect(() => {
        const updateDimension = () => {
            setScreenSize(getCurrentDimension())
        }
        window.addEventListener('resize', updateDimension);

        return (() => {
            window.removeEventListener('resize', updateDimension);
        })
    }, [screenSize])

    // Start of pdf page logicpage logic
    const [pageNum, setPageNum] = useState(1);
    const [maxPageNum, setMaxPageNum] = useState(1);

    function onDocumentLoadSuccess(data) { setMaxPageNum(data.numPages); }

    // TODO: refactor, this can be inlined somehow
    // If true - increment page, if false - decrement page
    const clamp = (num, min, max) => Math.min(Math.max(num, min), max);
    function walkPages(forward) {
        if (forward)
            setPageNum(clamp(pageNum + 1, 1, maxPageNum));
        else
            setPageNum(clamp(pageNum - 1, 1, maxPageNum));
    }

    return (
        <div>
            <a id="download" href={'NathanBeals_Resume.pdf'} target="_blank" rel="noreferrer">Download</a>
            <br></br>
            <button onClick={() => walkPages(false)}>&lt;&lt;</button>
            <button onClick={() => walkPages(true)}>&gt;&gt;</button>
            <div className='pageNumber'>Page {pageNum} of {maxPageNum}</div>
            <Document file="NathanBeals_Resume.pdf" onLoadSuccess={onDocumentLoadSuccess}>
                <Page width={Math.min(screenSize.width * .8, 1000)} canvasBackground='white' pageNumber={pageNum} />
            </Document>
        </div>
    );
}